import { render } from "./TransactionCard.vue?vue&type=template&id=1c4dbd34&scoped=true"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"

import "./TransactionCard.vue?vue&type=style&index=0&id=1c4dbd34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4dbd34"]])

export default __exports__